<template>
  <div class="main">
    <!--loader-->
    <Loader :isVisible="loading" :loadingText="loadText" :isFullScreen="true" />

    <div id="label">
      <label for="invno" style="font-weight: bold" v-text="isInv ? 'Invoice Documents' : 'Job Documents'"
        >{{ title }} <br
      /></label>
      <div class="invNumber" v-text="isInv ? invno : jobno">{{ number }}</div>
    </div>

    <div class="left-container" id="top">
      <button
        class="selectAll"
        v-if="selectedDocument.length < fullDocumentsList.length"
        @click="selectAllClicked()"
        style="z-index: 100; position: absolute"
        >View All</button
      >
      <button class="selectAll" v-else @click="selectAllClicked()" style="z-index: 100; position: absolute" disabled
        >View All</button
      >

      <button class="clearAll" v-if="selectedDocument.length > 0" @click="clearAll()">Clear All</button>
      <button class="clearAll" v-else @click="clearAll()" disabled>Clear All</button>

      <!--drpdwn button-->
      <div id="PDbutton" class="button-download-print dropup" title="Download or Print" data-toggle="dropdown">
        <img src="https://img.icons8.com/android/24/000000/download.png" />
        <div>/</div>
        <img src="https://img.icons8.com/android/24/000000/print.png" />
      </div>

      <!--dropdown container-->
      <div id="PDcontainer" class="dropdown-menu download-print-menu">
        <!--dropdown options-->
        <div id="PDoptions" class="print-download-menu" @click="printData()">
          <img src="https://img.icons8.com/office/80/000000/print.png" />
          <div>Print here</div>
        </div>
        <div id="PDoptions" class="print-download-menu" @click="exportTableToCSV()">
          <img src="https://img.icons8.com/office/80/000000/csv.png" />
          <div>Download CSV</div>
        </div>
        <div id="PDoptions" class="print-download-menu" @click="tableToExcel()">
          <img src="https://img.icons8.com/office/80/000000/xls.png" />
          <div>Download XLSX</div>
        </div>
      </div>

      <Tabulator
        tableID="docsTabulator"
        tableTitle="Documents"
        :tableData="fullDocumentsList"
        :additionalColumn="Actions"
        @cellButtonClick="viewDocs"
        :hideColumns="['AttImage']"
        :multiSelect="0"
      />
    </div>

    <div class="right-container">
      <div class="Selected" v-if="selectedDocument.length > 0">
        <div class="dataDisplay" v-for="(item, index) in selectedDocument" :key="index" :id="'view' + index">
          <img
            class="removeImage"
            src="https://icon-library.com/images/cancel-icon-transparent/cancel-icon-transparent-19.jpg"
            @click="closeImage(item)"
          />
          <table>
            <tr>
              <th>#</th>
              <td class="index" style="font-weight: bold"> : {{ item['#'] }}</td>
            </tr>
            <tr>
              <th>Reference Number</th>
              <td> : {{ item['Reference No'] }}</td>
            </tr>
          </table>
          <!-- <button :isDisabled="item['AttImageType'] == 'n/a'" style="margin-bottom: 10px;" class="FullButton" @click="fullClicked(item)">View</button> -->
          <div v-if="item['AttImageType'] == 'n/a'" style="margin: auto">No Attachment Added</div>
          <div v-else class="image-container">
            <!-- <object :data="attachmentList[currentAttachmentIndex]['AttImage']"></object> -->
            <div
              class="image-container-hidden-div"
              v-if="viewableFormat.includes(item['AttImageType'] ? item['AttImageType'].trim().toLowerCase() : '')"
              style="width: 100%; position: absolute"
              @click="openAttPopup(item)"
            >
            </div>
            <!-- <object v-show="viewableFormat.includes(item['AttImageType'] ? item['AttImageType'].trim() : '')" :data="item['AttImage']" style="pointer-events: none;"></object> -->
            <div
              style="height: calc(100% - 50px)"
              v-if="viewableFormat.includes(item['AttImageType'] ? item['AttImageType'].trim().toLowerCase() : '')"
            >
              <img v-if="item['AttImageType'].includes('image/')" :src="item['AttImage']"/>
              <object v-else :data="item['AttImage']" style="pointer-events: none"></object>
            </div>
            <div style="height: calc(100% - 50px)" v-else>
              <div
                >File type <b>{{ item['AttImageType'] }}</b> is not viewable.<br />Please use the download button below
                to download the attachment</div
              >
              <a
                :href="item['AttImage']"
                :target="
                  viewableFormat.includes(item['AttImageType'] ? item['AttImageType'].trim().toLowerCase() : '') ?
                    '_blank'
                  : ''
                "
                :download="item['AttImageName'] ? item['AttImageName'] : 'temp'"
                >Download Attachment</a
              >
            </div>
            <!-- <div v-else>
            <div>File type <b>{{item['AttImageType']}}</b> is not viewable.<br>Please use the download button below to download the attachment</div>
          </div>           -->
            <!-- <iframe v-if="item['AttImageType'].trim() === '.pdf' || item['AttImageType'].trim() === '.ogg' " :src="item['AttImage']" @click="openAttPopup(item)"></iframe>
          <img v-else-if="item['AttImageType'].trim() === '.pptx'" src="https://i.ibb.co/n3904Sm/ppt.png" @click="downloadFile(item)"/>
          <img v-else-if="item['AttImageType'].trim() === '.xlsx'" src="https://i.ibb.co/JFp0hrh/excel.png" @click="downloadFile(item)" />
          <img v-else-if="item['AttImageType'].trim() === '.msg' || item['AttImageType'].trim() === '.eml'" src="https://i.ibb.co/sjQCXt2/mail.png" @click="downloadFile(item)" />
          <img v-else-if="item['AttImageType'].trim() === '.docx'" src="https://i.ibb.co/PtPtyLZ /word.png" @click="downloadFile(item)" />
          <img v-else-if="item['AttImageType'].trim() === '.jpg' || item['AttImageType'].trim() === 'image/Jpeg' || item['AttImageType'].trim() === 'image/jpeg' || item['AttImageType'].trim() === '.jpeg' || item['AttImageType'].trim() === '.png' || item['AttImageType'].trim() === '.gif'" :src="item['AttImage']" @click="openAttPopup(item)" />
          <img v-else src="https://i.ibb.co/zFJ847L/atchment.png" style="width:30%;" alt="" @click="downloadFile(item)"/> -->
          </div>
        </div>
      </div>

      <div class="notSelected" v-else> Select document(s) to view </div>
    </div>

    <!--Attachment Window-->
    <div class="attchWin-main" v-if="attachPopup">
      <button class="attchWin-close" @click="closeAttPopup()">X</button>
      <div class="attchWin-display">
        <div class="left">
          <div class="leftButton" v-if="selectedDocument.length > 1">
            <button class="navButton-left" @click="navAtt('prev')">&lt;</button>
          </div>

          <!-- image container and buttons -->
          <div class="attchWin-attachment">
            <!--QYVOON -->
            <!-- <img v-if="this.attToView ==='No Attachment Added'" src="https://i.ibb.co/kyZfpjx/no-image.png"/>
            <iframe v-else-if="this.attType === '.ogg' || this.attType ==='.pdf'"   :src="this.attToView"/>
            <img v-else-if="this.attType === '.jpg' || this.attType === 'image/Jpeg' || this.attType === '.jpeg' || this.attType === 'image/jpeg' || this.attType === '.png' || this.attType === '.gif'"   :src="this.attToView" />
            <img style="width:30%;" v-else-if="this.attType === '.docx'" src="https://i.ibb.co/PtPtyLZ /word.png"  @click="downloadpop()"/>
            <img style="width:30%;" v-else-if="this.attType === '.pptx'" src="https://i.ibb.co/n3904Sm/ppt.png" @click="downloadpop()"/>
            <img style="width:30%;" v-else-if="this.attType === '.msg' || this.attType === '.eml'" src="https://i.ibb.co/sjQCXt2/mail.png" @click="downloadpop()"/>
            <img style="width:30%;" v-else-if="this.attType === '.xlsx'" src="https://i.ibb.co/JFp0hrh/excel.png"  @click="downloadpop()"/>
            <img v-else src="https://i.ibb.co/zFJ847L/atchment.png" style="width:30%;" @click="downloadpop()"> -->
            <object
              v-if="viewableFormat.includes(attType ? attType.trim().toLowerCase() : '') && showBigAttachment"
              :data="attToView"
            ></object>
            <div
              v-else-if="attType == 'n/a'"
              style="
                background-color: white;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div>No Attachment Added</div>
            </div>
            <div
              v-else
              style="
                background-color: white;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div
                >File type <b>{{ attType }}</b> is not viewable.<br />Please use the download button below to download
                the attachment</div
              >
              <a
                :href="attToView"
                :target="viewableFormat.includes(attType ? attType.trim().toLowerCase() : '') ? '_blank' : ''"
                :download="attImageName"
                >Download Attachment</a
              >
            </div>
          </div>

          <div class="rightButton" v-if="selectedDocument.length > 1">
            <button class="navButton-right" @click="navAtt('next')">></button>
          </div>
        </div>

        <div class="right">
          <!-- table -->
          <div class="attchWin-info" style="overflow-x: auto">
            <table>
              <tr>
                <th> # </th>
                <td>:{{ noToView }}</td>
              </tr>

              <tr>
                <th> Reference Number </th>
                <td>:{{ refToView }} </td>
              </tr>

              <tr>
                <th> Job No </th>
                <td>:{{ jobnoToView }} </td>
              </tr>

              <tr>
                <th> Container Number </th>
                <td>:{{ containerToView }} </td>
              </tr>

              <tr>
                <th> Remarks </th>
                <td>:{{ remarksToView }} </td>
              </tr>
            </table>
            <a
              :href="attToView"
              :target="viewableFormat.includes(attType ? attType.trim().toLowerCase() : '') ? '_blank' : ''"
              :download="attImageName"
              >Download Attachment</a
            >
          </div>
        </div>
      </div>
    </div>

    <div v-if="showExpand" class="image-container-expand">
      <img
        class="closeImage"
        src="https://icon-library.com/images/cancel-icon-transparent/cancel-icon-transparent-19.jpg"
        @click="showExpand = !showExpand"
      />
      <!-- <iframe v-if="selectedExpandDocument['AttImageType'].trim() === '.pdf' || selectedExpandDocument['AttImageType'].trim() === '.ogg' " :src="selectedExpandDocument['AttImage']" @click="openAttPopup(selectedExpandDocument)"></iframe> -->
      <iframe
        v-if="
          selectedExpandDocument['AttImageType'].trim() === '.pdf' ||
          selectedExpandDocument['AttImageType'].trim() === '.ogg'
        "
        :src="
          selectedExpandDocument['AttImageType'].trim() === '.pdf' ?
            `${selectedExpandDocument['AttImage']}#view=FitH`
          : selectedExpandDocument['AttImage']
        "
        @click="openAttPopup(selectedExpandDocument)"
      ></iframe>
      <img
        v-else-if="selectedExpandDocument['AttImageType'].trim() === '.pptx'"
        src="https://i.ibb.co/n3904Sm/ppt.png"
        @click="downloadFile(selectedExpandDocument)"
      />
      <img
        v-else-if="selectedExpandDocument['AttImageType'].trim() === '.xlsx'"
        src="https://i.ibb.co/JFp0hrh/excel.png"
        @click="downloadFile(selectedExpandDocument)"
      />
      <img
        v-else-if="
          selectedExpandDocument['AttImageType'].trim() === '.msg' ||
          selectedExpandDocument['AttImageType'].trim() === '.eml'
        "
        src="https://i.ibb.co/sjQCXt2/mail.png"
        @click="downloadFile(selectedExpandDocument)"
      />
      <img
        v-else-if="selectedExpandDocument['AttImageType'].trim() === '.docx'"
        src="https://i.ibb.co/PtPtyLZ /word.png"
        @click="downloadFile(selectedExpandDocument)"
      />
      <img
        v-else-if="
          selectedExpandDocument['AttImageType'].trim() === '.jpg' ||
          selectedExpandDocument['AttImageType'].trim() === 'image/Jpeg' ||
          selectedExpandDocument['AttImageType'].trim() === 'image/jpeg' ||
          selectedExpandDocument['AttImageType'].trim() === '.jpeg' ||
          selectedExpandDocument['AttImageType'].trim() === '.png' ||
          selectedExpandDocument['AttImageType'].trim() === '.gif'
        "
        :src="selectedExpandDocument['AttImage']"
        @click="openAttPopup(selectedExpandDocument)"
      />
      <img
        v-else
        src="https://i.ibb.co/zFJ847L/atchment.png"
        style="width: 30%"
        alt=""
        @click="downloadFile(selectedExpandDocument)"
      />
    </div>

    <div v-if="!fullDocumentsList">No Data Found</div>
    <table v-else id="printTable">
      <tbody>
        <tr>
          <th style="width: 30px">#</th>
          <th style="width: 70px">Reference No</th>
          <th style="width: 50px">Category</th>
          <th style="width: 50px">Type</th>
          <th style="width: 70px">Received DateTime</th>
          <th style="width: 70px">Document Date</th>
          <th>Job No</th>
          <th>Consgt No</th>
          <th>Container No</th>
          <th>UserID</th>
          <th>Remarks</th>
          <th>Status</th>
          <th>Sets</th>
          <th>Pages</th>
          <th>DocGUID</th>
          <th>ImgType</th>
          <th>Src</th>
          <th>Att</th>
        </tr>
        <tr v-for="(document, index) in fullDocumentsList" :key="index">
          <td>{{ document['#'] }}</td>
          <td>{{ document['Reference No'] }}</td>
          <td>{{ document['Category'] }}</td>
          <td>{{ document['Type'] }}</td>
          <td>{{ document['Received DateTime'] }}</td>
          <td>{{ document['Document Date'] }}</td>
          <td>{{ document['Job No'] }}</td>
          <td>{{ document['Consignment No'] }}</td>
          <td>{{ document['Container No'] }}</td>
          <td>{{ document['UserID'] }}</td>
          <td>{{ document['Remarks'] }}</td>
          <td>{{ document['Status'] }}</td>
          <td>{{ document['Sets'] }}</td>
          <td>{{ document['Pages'] }}</td>
          <td>{{ document['DocumentGUID'] }}</td>
          <td>{{ document['AttImageType'] }}</td>
          <td>{{ document['Source'] }}</td>
          <td v-if="document['AttImageType'] != 'n/a'" style="width: 20%"
            ><img :src="document['AttImage']" height="200px" width="110px;"
          /></td>
          <td v-else style="width: 20%">No Image</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Loader,
    Tabulator,
  },
  data: function () {
    return {
      viewableFormat: [
        '.gif',
        '.jpg',
        '.jpeg',
        '.jfif',
        '.pjpeg',
        '.pjp',
        '.png',
        '.svg',
        '.pdf',
        '.txt',
        '.json',
        '.mp4',
        'image/jpeg',
      ],
      showBigAttachment: false,

      isInv: false,
      title: '',
      number: '',

      loadText: '',
      loading: false,
      invno: '',
      config: '',
      userID: '',
      errorMessage: '',
      jobno: '',

      //table
      fullDocumentsList: [], //complete job document list
      selectedDocument: [], //selected document row
      Actions: [{ value: 'View', type: 'button', index: 0, frozen: true }],

      //Attachment popup
      attachPopup: false,
      attToView: '',
      noToView: '',
      refToView: '',
      jobnoToView: '',
      containerToView: '',
      remarksToView: '',
      attType: '',
      attImageName: '',

      //excel
      excel: [],

      //expand document
      showExpand: false,
      selectedExpandDocument: [],
    };
  },
  props: {
  },
  methods: {
    viewDocs: function (_btn, data) {
      // let id = this.selectedDocument.indexOf(data);
      // let list = this.selectedDocument;

      const id2 = this.selectedDocument.findIndex((list) => list['#'] == data['#']);

      if (id2 < 0 && this.selectedDocument.length < this.fullDocumentsList.length) {
        this.selectedDocument.push(data);
        /* var a = document.getElementById('docsTabulator').indexOf(btn);
      alert(a); */
      } else {
        const target = document.getElementById('view' + id2);
        this.blinker(target, 1200);

        target.scrollIntoView();
      }
    },
    blinker: function (element, duration) {
      element.style.backgroundColor = '#b3c4ff';
      setTimeout(function () {
        element.style.backgroundColor = '#efefef';
      }, duration);
    },
    checknull: function (value) {
      if (value.length != 0) {
        return value;
      } 
      return 'null';
    },
    copy: function (x) {
      return JSON.parse(JSON.stringify(x));
    },
    callAPI: async function () {
      try {
        this.loading = true;
        this.loadText = `Getting Documents`;

        if (!this.invno && !this.jobno) {
          this.$showAlert('error', 'No Job/Invoice Number Specified');
          return;
        }

        const API = this.invno ? 'GetInvDocuments' : 'GetJobDocuments';
        const docNo = this.invno ? `invno=${this.invno}` : `jobno=${this.jobno}`;
        const docAPI = await this.$apiCallV2(
          `/JobDocuments/${API}?config=${this.config}&userid=${this.userID}&${docNo}`,);

        // if (this.invno) {
        //   this.isInv = true;
        //   let docAPI = await this.$apiCallV2(
        //     `/JobDocuments/GetInvDocuments?config=${this.config}&userid=${this.userID}&invno=${this.invno}`,
        //   );
        // } else if (this.jobno) {
        //   this.isInv = false;
        //   let docAPI = await this.$apiCallV2(
        //     `/JobDocuments/GetJobDocuments?jobno=${this.jobno}&config=${this.config}&userid=${this.userID}`,
        //   );
        // } else {
        //   this.$showAlert('error', 'No Job/Invoice Number Specified');
        //   return;
        // }

        this.fullDocumentsList = docAPI;

        this.loadText = `Getting Images`;
        this.convertImage();

        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$showAlert(
          'error',
          `No records found for ${!this.jobno ? this.invno : this.jobno}. Please try again \n ${e}`,
        );
      }

      document.getElementById('top').style.visibility = 'visible';
    },
    convertImage: function () {
      //loop to get and convert all attImg

      try {
        for (let j = 0; j < this.fullDocumentsList.length; j++) {
          if (this.fullDocumentsList[j]['AttImageType'] == null) {
            this.fullDocumentsList[j]['AttImageType'] = 'n/a';
          } 
          // else {
          const type = this.fullDocumentsList[j]['AttImageType'].trim();
          // }

          //if empty
          if (this.fullDocumentsList[j]['AttImage'] == null || this.fullDocumentsList[j]['AttImage'].length == 0) {
            this.fullDocumentsList[j]['AttImage'] = 'No Attachment Added';
            continue;
          }

          const byteCharacters = atob(this.fullDocumentsList[j]['AttImage']);
          const byteArray = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
          }

          switch (type) {
            case '.pdf':
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(
                new Blob([byteArray], { type: 'application/pdf' }),
              );
              break;

            case '.xlsx':
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(
                new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
              );
              break;

            case '.ogg':
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(new Blob([byteArray], { type: 'audio/ogg' }));
              break;

            case '.pptx':
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(
                new Blob([byteArray], {
                  type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                }),
              );
              break;

            case '.docx':
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(
                new Blob([byteArray], {
                  type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                }),
              );
              break;

            case '.msg':
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(
                new Blob([byteArray], { type: 'application/vnd.msoutlook' }),
              );
              break;

            default:
              this.fullDocumentsList[j]['AttImage'] = URL.createObjectURL(new Blob([byteArray], { type: 'image/png' }));
              break;
          }
        }
      } catch (e) {
        // do nothing
      }
    },
    // parseJsonDate: function (jsonDateString) {
    //   try {
    //     if (jsonDateString != null) {
    //       let xformatedDate = new Date(parseInt(jsonDateString.replace('/Date(', '')));

    //       function pad(s) {
    //         return s < 10 ? '0' + s : s;
    //       }

    //       let d = new Date(xformatedDate);

    //       return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
    //     } else {
    //       return 'No Date';
    //     }
    //   } catch (e) {
    //     // alert(e);
    //     this.$showAlert('error', `${e}`);
    //   }
    // },
    //download onCLick for popup
    // downloadpop: function () {
    //   let doc = this.attToView;
    //   let reference = this.refToView;

    //   let type = this.attType.trim();

    //   let link = document.createElement('a');
    //   link.href = doc;
    //   link.download = this.invno + '_' + reference + type;
    //   link.click();
    // },
    //download onClick
    downloadFile: function (number) {
      const doc = number['AttImage'];
      let reference = number['Reference No'];

      if (!reference) {
        reference = 'Document-' + number['#'];
      }

      const type = number['AttImageType'].trim();

      const link = document.createElement('a');
      link.href = doc;
      link.download = this.invno + '_' + reference + type;
      link.click();
    },
    printData: function () {
      const divContents = document.getElementById('printTable').outerHTML;
      const a = window.open('', 'blank');
      const htmlToPrint =
        '' +
        '<head><style type="text/css">@page {size: A4 landscape} ' +
        '#printTable {' +
        'border:1px solid black;' +
        'visibility: visible;' +
        'width: calc(100% -10px);' +
        'font-size:12px;' +
        'margin:0 auto;' +
        'text-align:center;' +
        'border-collapse:collapse;' +
        '}' +
        'td {' +
        'max-width: 70px;' +
        'overflow: hidden;' +
        'border:1px solid black;' +
        '}' +
        'th {' +
        'border:1px solid black;' +
        'background:#b3c4ff;' +
        'max-width: 60px;' +
        '}' +
        'tr {' +
        'border:none;' +
        '}' +
        '</style></head>';
      a.document.write('<html>');
      a.document.write(htmlToPrint);
      a.document.write(
        `<body> <h1>${this.isInv ? 'Invoice Documents' : 'Job Documents'}: ${this.isInv ? this.invno : this.jobno}<br>`,
      );
      a.document.write(divContents);
      a.document.write('</body></html>');
      a.document.close();

      a.print();
      a.onafterprint = function () {
        a.close();
      };
    },
    downloadCSV: function (csv, filename) {
      // let csvFile;
      // let downloadLink;

      // CSV file
      const csvFile = new Blob([csv], { type: 'text/csv' });

      // Download link
      const downloadLink = document.createElement('a');

      // File name
      downloadLink.download = filename;

      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);

      // Hide download link
      downloadLink.style.display = 'none';

      // Add the link to DOM
      document.body.appendChild(downloadLink);

      // Click download link
      downloadLink.click();
    },
    exportTableToCSV: function () {
      const filename = `${this.isInv ? this.invno : this.jobno}.csv`;
      const csv = [];
      const rows = document.getElementById('printTable').querySelectorAll('tr');

      for (let i = 0; i < rows.length; i++) {
        const row = [],
          cols = rows[i].querySelectorAll('td, th');

        for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);

        csv.push(row.join(','));
      }

      // Download CSV file
      this.downloadCSV(csv.join('\n'), filename);
    },
    //export to xlsx - Only supports up to JSON - 9mb file size - approx 13 records
    tableToExcel: async function () {
      //add variables for rowStart and rowEnd
      let start = 0;
      let end = 1;
      this.excel = this.copy(this.fullDocumentsList);

      for (let i = 0; i < this.excel.length; i++) {
        start += 1;
        end += 1;

        this.excel[i]['rowStart'] = start;
        this.excel[i]['rowEnd'] = end;
        this.excel[i]['id'] = 'img' + i;
        let image = this.excel[i]['AttImage'];
        const type = this.excel[i]['AttImageType'].trim();
        if (
          type === '.jpg' ||
          type === 'image/Jpeg' ||
          type === '.jpeg' ||
          type === 'image/jpeg' ||
          type === '.png' ||
          type === '.gif'
        ) {
          if (image) {
            this.loading = true;
            this.loadText = 'Getting Images';

            image = await this.resizeImage(image, 150, 2).then((res) => {
              this.excel[i]['AttImage'] = res;
            });
            //excel[i]["AttImage"] = res;
            /* image = await this.resizeBase64Img(image,400,100).then((res)=>{
          this.excel[i]['AttImage']= res; });  */

            this.excel[i]['AttImage'] = this.excel[i]['AttImage'].split(',')[1];
          }
        } else if (!image) {
          //do nothing
        } else {
          this.excel[i]['AttImage'] =
            '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';
        }
      }
      //change array to object
      const rv = Object.assign({}, this.excel); // {0:"a", 1:"b", 2:"c"};

      this.excel = { rv };

      //call API
      try {
        this.loadText = 'Creating XLSX';

        const jsReportPDF = await this.$apiCallV2(
          'https://playground.jsreport.net/w/hernglx/sTlzeYbW/api/report',
          {
            template: { shortid: 'r1xkQzrVaE' },
            data: this.excel,
            options: {
              reportName: 'myfilename.xlsx',
              'Content-Disposition': 'attachment;filename=report.xlsx',
              reports: { async: true, blobName: 'myfilename' },
            },
          },
          {
            responseType: 'arraybuffer',
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            express: {
              inputRequestLimit: '1000mb',
            },
          },
        );
        const currentdate = new Date();
        const datetime = currentdate.getFullYear() + '-' + (currentdate.getMonth() + 1) + '-' + currentdate.getDate();

        this.loading = false;

        //create file
        const contentType = jsReportPDF.headers['content-type'];
        const blob = new Blob([jsReportPDF.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${this.isInv ? this.invno : this.jobno} date-${datetime}.xlsx`;
        link.click();
      } catch (e) {
        this.loading = false;
        this.errorMessage = 'There was an error while creating your report';
        // alert(this.errorMessage);
        this.$showAlert('error', 'There was an error while creating your report');
      }
    },
    //reduce image file
    urltoFile: function (url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
    resizeImage: async function (dataUrl, targetFileSizeKb, maxDeviation) {
      const originalFile = await this.urltoFile(dataUrl, this.refToView + this.attType, this.attType);
      if (originalFile.size / 1000 < targetFileSizeKb) return dataUrl; // File is already smaller

      let low = 0.0;
      let middle = 0.5;
      let high = 1.0;

      let result = dataUrl;

      let file = originalFile;

      while (Math.abs(file.size / 1000 - targetFileSizeKb) > maxDeviation) {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const img = document.createElement('img');

        const promise = new Promise((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = reject;
        });

        img.src = dataUrl;

        await promise;

        canvas.width = Math.round(img.width * middle);
        canvas.height = Math.round(img.height * middle);
        context.scale(canvas.width / img.width, canvas.height / img.height);
        context.drawImage(img, 0, 0);
        file = await this.urltoFile(canvas.toDataURL(), 'test.png', 'image/png');

        if (file.size / 1000 < targetFileSizeKb - maxDeviation) {
          low = middle;
        } else if (file.size / 1000 > targetFileSizeKb) {
          high = middle;
        }

        middle = (low + high) / 2;
        result = canvas.toDataURL();
      }

      return result;
    },
    //compress image 2
    // resizeBase64Img: function (base64, newWidth, newHeight) {
    //   return new Promise((resolve, reject) => {
    //     const canvas = document.createElement('canvas');
    //     canvas.style.width = newWidth.toString() + 'px';
    //     canvas.style.height = newHeight.toString() + 'px';
    //     const context = canvas.getContext('2d');
    //     const img = document.createElement('img');
    //     img.src = base64;
    //     img.onload = function () {
    //       context.scale(newWidth / img.width, newHeight / img.height);
    //       context.drawImage(img, 0, 0);
    //       resolve(canvas.toDataURL());
    //     };
    //   });
    // },
    closeImage: function (index) {
      //remove content from view panel
      //get id, get index, remove from array

      const remove = this.selectedDocument.indexOf(index);
      this.selectedDocument.splice(remove, 1);
      this.removed.push(index);
    },
    selectAllClicked: function () {
      this.selectedDocument = [];
      const allDoc = this.copy(this.fullDocumentsList);

      this.selectedDocument = allDoc;
    },
    clearAll: function () {
      this.selectedDocument = [];
    },
    openAttPopup: function (index) {
      this.showBigAttachment = true;
      // console.log(this.attachPopup);
      this.attachPopup = true;
      // console.log(this.attachPopup);
      this.attToView = index['AttImage'];
      // console.log(this.attToView)
      this.noToView = index['#'];
      // console.log(this.noToView);
      this.refToView = index['Reference No'];
      // console.log(this.refToView);
      this.jobnoToView = index['Job No'];
      // console.log(this.jobnoToView)
      // this.containerToView = this.checknull(index['Container No']);
      this.containerToView = '';
      // console.log(this.containerToView)
      this.remarksToView = this.checknull(index['Remarks']);
      // console.log(this.remarksToView)
      this.attType = index['AttImageType'].trim();
      // console.log(this.attType);
      this.attImageName = index['AttImageName'].trim();
    },
    closeAttPopup: function () {
      this.attachPopup = false;

      this.attToView = '';
      this.noToView = '';
      this.refToView = '';
      this.jobnoToView = '';
      this.containerToView = '';
      this.remarksToView = '';
    },
    navAtt: function (clicked) {
      this.showBigAttachment = false;
      const getIndex = this.fullDocumentsList[this.noToView - 1];
      let inArray = this.selectedDocument.indexOf(getIndex);

      for (let a = 0; a < this.selectedDocument.length; a++) {
        if (getIndex['#'] == this.selectedDocument[a]['#']) {
          inArray = a;
        }
      }

      // const curr = this.noToView - 1;
      let next;
      const length = this.selectedDocument.length;
      const end = length - 1;

      if (clicked == 'prev') {
        if (inArray == 0) {
          next = end;
        } else {
          next = inArray - 1;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (inArray == end) {
          next = 0;
        } else {
          next = inArray + 1;
        }
      }

      this.$nextTick(() => {
        this.showBigAttachment = true;
        this.attToView = this.selectedDocument[next]['AttImage'];
        this.noToView = this.selectedDocument[next]['#'];
        this.refToView = this.selectedDocument[next]['Reference No'];
        this.jobnoToView = this.selectedDocument[next]['Job No'];
        // this.containerToView = this.checknull(this.selectedDocument[next]['Container No']);
        this.containerToView = '';
        this.remarksToView = this.checknull(this.selectedDocument[next]['Remarks']);
        this.attType = this.selectedDocument[next]['AttImageType'].trim();
        this.attImageName = this.selectedDocument[next]['AttImageName'].trim();
      });
    },
    // externalScript: function (src) {
    //   const externalScript = document.createElement('script');
    //   externalScript.setAttribute('src', src);
    //   document.body.appendChild(externalScript);
    // },
    // fullClicked: function(item) {
    //   this.selectedExpandDocument = [];
    //   console.log(item);
    //   this.showExpand = true;
    //   this.selectedExpandDocument = item;
    //   console.log(this.selectedExpandDocument);
    // },
  },
  mounted() {
    // this.invno = this.$route.params.invno;
    // this.jobno = this.$route.params.jobno;
    // this.config = this.$route.params.config;
    // this.userID = this.$route.params.userID;

    // let query = this.$route.query;
    const params = this.$route.params;

    if (params['userID']) {
      this.userID = params['userID'];
    }
    if (params['config']) {
      this.config = params['config'];
    }
    if (params['jobno']) {
      this.jobno = params['jobno'];
    }
    if (params['invno']) {
      this.invno = params['invno'];
    }

    this.callAPI();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
@media print {
  @page {
    size: landscape;
  }
  .printButton {
    display: none !important;
  }
}

#PDbutton {
  position: absolute;
  z-index: 3;
  background: white;
  left: 85px;
  top: 7px;
  font-size: 12px;
  padding: 7px 5px;
  display: flex;
  border-radius: 3px;
  cursor: pointer;

  img {
    height: 15px;
    margin: 0 3px;
  }
  &:hover {
    background-color: rgb(200, 200, 200);
  }
}

.main {
  overflow: scroll;
  height: 100%;
  width: 100%;
  text-align: center;

  > .left-container {
    height: 300px;
    margin: 5px;
    background-color: white;
    border-radius: 5px;
    position: relative;
    padding: 5px;
    width: calc(100% - 10px);
    visibility: hidden;

    > .selectAll {
      position: absolute;
      z-index: 3;
      top: 7px;
      left: 190px;
    }

    > .clearAll {
      position: absolute;
      z-index: 3;
      top: 7px;
      left: 280px;
    }

    #PDcontainer {
      border: 1px solid black;
      border-radius: 3px;
      padding: 5px;
      font-size: 12px;
      cursor: pointer;

      > #PDoptions {
        padding: 3px 5px;
        margin: 3px 0;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;

        > img {
          height: 15px;
          margin-right: 5px;
        }

        &:hover {
          background-color: rgba(200, 200, 200, 0.8);
        }
      }
    }
  }

  > .right-container {
    background-color: white;
    border-radius: 5px;
    margin: 5px;
    //padding: 5px 10px;
    width: calc(100% - 10px);
    height: calc(100% - 390px);
    display: flex;
    flex-direction: column;

    > .container-title {
      height: 25px;
      font-weight: bold;
      text-align: center;
    }

    > .notSelected {
      margin: auto;
      font-size: 12px;
      position: relative;
    }

    > .Selected {
      height: calc(100% - 10px);
      width: calc(100%-10px);
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;

      > .dataDisplay {
        /* margin:auto; */
        font-size: 12px;
        float: left;
        position: relative;
        // height:100%;
        min-width: 250px;
        max-width: 250px;
        margin: 5px;
        background: #efefef;
        border-radius: 3px;

        //max-width:250px;
        > .removeImage {
          height: 20px;
          margin: 5px;
          float: right;
          cursor: pointer;
        }

        > table {
          width: 88%;
          border: none;
          display: inline-block;
          table-layout: fixed;
          margin-bottom: 5px;
          text-align: left;

          td {
            max-width: 150px;
            overflow: hidden;
            white-space: nowrap;
          }
        }

        > .image-container {
          // width:150px;
          // margin:auto;
          // height: calc(100% - 78.2px);
          width: 100%;
          height: calc(100% - 50px);

          > .image-container-hidden-div {
            cursor: pointer;
            height: calc(100% - 50px);

            &:hover {
              box-shadow: 2px 2px 5px #555353;
            }
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;

            &:hover {
              cursor: pointer;
              box-shadow: 2px 2px 5px #555353;
            }
          }

          object {
            width: 100%;
            height: 100%;
            object-fit: contain;
            padding: 10px;
          }
        }
      }
    }
  }

  //attachment popup
  > .attchWin-main {
    width: calc(100%);
    height: calc(100% - 10px);
    padding: 5px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    background-color: #00000048;
    z-index: 255;

    > .attchWin-close {
      height: 30px;
      width: 30px;
      font-weight: bold;
      border-radius: 50%;
      background-color: white;
      color: black;
      text-align: center;
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      margin: 20px;
      font-size: 14px;
    }

    > .attchWin-display {
      width: 90%;
      margin: 0 auto;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background-color: #eaeaea;
      border-radius: 3px;
      display: flex;
      height: 90vh;

      > .left {
        position: relative;
        float: left;
        width: 100%;
        height: 100%;
        border: 1px solid black;
        background: black;
        height: 100%;
        text-align: center;
        display: flex;

        > .leftButton {
          width: auto;
          height: 100%;
          float: left;
          align-items: center;
          left: 0;

          > .navButton-left {
            margin: 0 auot;
            position: relative;
            z-index: 300;
            font-size: 36px;
            color: white;
            background: none;
            top: 50%;

            &:hover {
              cursor: pointer;
              background: rgba(200, 200, 200, 0.8);
            }
          }
        }

        > .rightButton {
          width: auto;
          height: 100%;
          float: right;
          align-items: center;

          > .navButton-right {
            margin: 0;
            position: relative;
            top: 50%;
            float: right;
            /* -webkit-transform: translateY(-50%);
        transform: translateY(-50%); */
            z-index: 300;
            font-size: 36px;
            color: white;
            background: none;

            &:hover {
              cursor: pointer;
              background: rgba(200, 200, 200, 0.8);
            }
          }
        }

        > .attchWin-attachment {
          position: relative;
          margin: 0 auto;
          width: 100%;
          height: 100%;
          text-align: center;
          -o-object-fit: contain;
          object-fit: contain;
          float: left;
          align-self: center;
          //top: 25%;

          img {
            width: 100%;
            object-fit: contain;
            margin: 0 auto;
            max-height: 90vh;
          }

          &:hover {
            cursor: pointer;
          }

          object {
            object-fit: contain;
            width: 100%;
            height: 100%;
            min-height: 600px;
          }
        }
      }

      > .right {
        position: relative;
        float: left;
        width: 400px;
        height: 100%;
        min-width: 250px;
        border: 1px solid black;

        > .attchWin-info {
          top: 280px;
          position: relative;
          margin: 18px;
          text-align: left;

          table {
            width: calc(100% - 10px);
            table-layout: fixed;
            font-size: 13px;
          }
        }
      }
    }
  }

  > #label {
    margin: 5px;
    width: calc(100% - 10px);
    height: auto;
    text-align: center;
    display: inline-grid;
    font-weight: 'bold';

    > .invNumber {
      border-bottom: 1px solid black;
      margin: 3px;
    }

    > .printButton {
      padding: 5px 8px;
      margin: auto;
      width: fit-content;
    }
  }

  > #printTable {
    display: none;
    border: 1px solid black;
    margin: 5px;
    width: calc(100% -10px);
    font-size: 12px;
    margin: 0 auto;

    td {
      max-width: 60px;
      overflow: hidden;
      border: 1px solid black;
    }

    th {
      border: 1px solid black;
      background: #b3c4ff;
    }
  }

  > .image-container-expand {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);

    > .closeImage {
      position: absolute;
      top: 10px;
      right: 10px;
      height: 20px;
      margin: 5px;
      // float:right;
      cursor: pointer;
    }

    iframe {
      width: 90%;
      height: 90%;
    }
  }
}
</style>
